import { useState, useEffect } from 'react';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Login from './components/Login';
import Register from './components/Register';
import VerifyOTP from './components/VerifyOTP';
import ForgotPassword from './components/ForgotPassword';
import Chat from './components/Chat';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [showHome, setShowHome] = useState(true);
  const [showAbout, setShowAbout] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [username, setUsername] = useState('');
  const [verifyEmail, setVerifyEmail] = useState('');
  const [verifyUsername, setVerifyUsername] = useState('');

  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    const adminUsername = localStorage.getItem('adminUsername');
    if (adminToken && adminUsername) {
      setIsAdmin(true);
      setUsername(adminUsername);
      setShowHome(false);
      return;
    }

    const token = localStorage.getItem('token');
    const savedUsername = localStorage.getItem('username');
    if (token && savedUsername) {
      setIsAuthenticated(true);
      setUsername(savedUsername);
      setShowHome(false);
    }

    if (window.location.pathname === '/admin') {
      setShowAdminLogin(true);
      setShowHome(false);
    }
  }, []);

  const handleGetStarted = () => {
    setShowHome(false);
    setShowAbout(false);
    setShowContact(false);
    setShowRegister(true);
  };

  const handleSignIn = () => {
    setShowHome(false);
    setShowAbout(false);
    setShowContact(false);
    setShowLogin(true);
  };

  const handleShowAbout = () => {
    setShowHome(false);
    setShowContact(false);
    setShowAbout(true);
  };

  const handleShowContact = () => {
    setShowHome(false);
    setShowAbout(false);
    setShowContact(true);
  };

  const handleBackToHome = () => {
    setShowAbout(false);
    setShowContact(false);
    setShowLogin(false);
    setShowRegister(false);
    setShowForgotPassword(false);
    setShowHome(true);
  };

  const handleForgotPassword = () => {
    setShowLogin(false);
    setShowForgotPassword(true);
  };

  const handleForgotPasswordSuccess = () => {
    setShowForgotPassword(false);
    setShowLogin(true);
  };

  const handleLoginSuccess = (user) => {
    setUsername(user);
    setIsAuthenticated(true);
    setShowLogin(false);
  };

  const handleRegisterSuccess = (email, user) => {
    setVerifyEmail(email);
    setVerifyUsername(user);
    setShowVerify(true);
    setShowRegister(false);
  };

  const handleVerifySuccess = (user) => {
    setUsername(user);
    setIsAuthenticated(true);
    setShowVerify(false);
  };

  const handleVerifyBack = () => {
    setShowVerify(false);
    setShowLogin(false);
    setShowHome(true);
  };

  const handleAdminLoginSuccess = (adminUser) => {
    setUsername(adminUser);
    setIsAdmin(true);
    setShowAdminLogin(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    setUsername('');
    setShowLogin(false);
    setShowHome(true);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    setIsAdmin(false);
    setUsername('');
    setShowAdminLogin(false);
    setShowHome(true);
  };

  if (isAdmin) {
    return <AdminPanel onLogout={handleAdminLogout} />;
  }

  if (showAdminLogin) {
    return <AdminLogin onLoginSuccess={handleAdminLoginSuccess} />;
  }

  if (isAuthenticated) {
    return <Chat username={username} onLogout={handleLogout} />;
  }

  if (showVerify) {
    return (
      <VerifyOTP
        email={verifyEmail}
        username={verifyUsername}
        onVerifySuccess={handleVerifySuccess}
        onBack={handleVerifyBack}
      />
    );
  }

  if (showForgotPassword) {
    return (
      <ForgotPassword
        onBack={() => {
          setShowForgotPassword(false);
          setShowLogin(true);
        }}
        onSuccess={handleForgotPasswordSuccess}
      />
    );
  }

  if (showRegister) {
    return (
      <Register
        onRegisterSuccess={handleRegisterSuccess}
        onSwitchToLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />
    );
  }

  if (showLogin) {
    return (
      <Login
        onLoginSuccess={handleLoginSuccess}
        onSwitchToRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
        onForgotPassword={handleForgotPassword}
      />
    );
  }

  if (showContact) {
    return <Contact onBack={handleBackToHome} />;
  }

  if (showAbout) {
    return <About onBack={handleBackToHome} />;
  }

  return <Home onGetStarted={handleGetStarted} onSignIn={handleSignIn} onShowAbout={handleShowAbout} onShowContact={handleShowContact} />;
}

export default App;
